import { ExclamationCircleOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import { ApiOptions, useApiMutation } from 'hooks/useApi';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useDownload(
  url: string | null,
  options: ApiOptions & { fallbackFilename?: string } = {},
): { download: () => void; isLoading: boolean } {
  const { fallbackFilename, ...apiOptions } = options;
  const downloadMutation = useApiMutation<void, Response>(url, {
    method: 'GET',
    isJson: false,
    ...apiOptions,
  });
  const { t } = useTranslation();

  const download = useCallback(async () => {
    try {
      const response = await downloadMutation.mutateAsync();

      const blob = await response.blob();
      const [, filename] =
        response.headers.get('Content-Disposition')?.match(/filename=(.+)$/) ||
        [];

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = filename || fallbackFilename || 'download';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.warn('Erreur lors du téléchargement du fichier', e);

      notification.open({
        icon: <ExclamationCircleOutlined />,
        message: t('global:internet_connexion_error'),
      });
    }
  }, [downloadMutation, t, fallbackFilename]);

  return { download, isLoading: downloadMutation.isLoading };
}
